import { createAction, props } from '@ngrx/store';
import { IAdminTokenPayload, IEMRLayout } from '@care-portals/api-interfaces';

export const loadAppLayouts = createAction(
  '[App] Load App Layouts',
  props<{ user: IAdminTokenPayload }>()
);
export const loadAppLayoutsSuccess = createAction(
  '[App] Load App Layouts Success',
  props<{ appLayouts: IEMRLayout[] }>()
);
export const loadAppLayoutsFailure = createAction(
  '[App] Load App Layouts Failure',
  props<{ error: any }>()
);
export const selectLayout = createAction(
  '[App] Select Brand',
  props<{ layout: string }>()
);
export const setActiveLayout = createAction(
  '[App] Select Active Brand',
  props<{ activeLayoutIndex: number }>()
);
